.hero {
  grid-area: hero;
  display: flex;
  align-items: flex-start;
  justify-content: start;
  padding-inline-start: var(--cxy-spacing-4);
  padding-inline-end: var(--cxy-spacing-1);
  max-width: 1360px;
  width: 100%;
  margin: auto;
  position: relative;
  overflow-x: hidden;
}
@media (min-width: 801px) {
  .hero {
    margin-block-end: var(--cxy-spacing-4);
  }
}
@media (min-width: 1360px) {
  .hero {
    overflow-x: visible;
    margin-block-end: var(--cxy-spacing-8);
  }
}

.textWrapper {
  padding: 0;
  z-index: var(--cxy-z-index-control-highest);
}
.textWrapper span[aria-label='Powered by Sport Radar'] {
  margin-top: var(--cxy-spacing-8);
}
.textWrapper h1,
.textWrapper b {
  color: var(--cxy-color-brand);
}
.textWrapper h1 {
  font-family: var(--cxy-font-family-futura);
}
.textWrapper h2,
.textWrapper h3,
.textWrapper p {
  color: var(--cxy-color-content-default);
}
.textWrapper h1 {
  font-size: var(--cxy-fontSize-xxl);
  line-height: var(--cxy-lineHeight-l);
  font-weight: var(--cxy-fontWeight-extraBold);
  text-transform: uppercase;
}
.textWrapper h2 {
  font-size: var(--cxy-fontSize-l);
  line-height: var(--cxy-lineHeight-l);
  font-weight: var(--cxy-fontWeight-semiBold);
}
.textWrapper.hideDetailsOnMobile h3,
.textWrapper.hideDetailsOnMobile b,
.textWrapper.hideDetailsOnMobile p {
  display: none;
}
@media (min-width: 801px) {
  .textWrapper.hideDetailsOnMobile h3,
  .textWrapper.hideDetailsOnMobile p {
    display: block;
  }
  .textWrapper.hideDetailsOnMobile b {
    display: inline;
  }
}
@media (min-width: 801px) {
  .textWrapper {
    padding-inline: var(--cxy-spacing-4);
  }
  .textWrapper h1 {
    font-size: var(--cxy-fontSize-xxxxl);
    line-height: var(--cxy-lineHeight-xxxl);
    font-weight: var(--cxy-fontWeight-extraBold);
  }
  .textWrapper h2 {
    font-size: var(--cxy-fontSize-xxxl);
    line-height: var(--cxy-lineHeight-xxl);
    font-weight: var(--cxy-fontWeight-semiBold);
    margin-block-end: 55px;
  }
  .textWrapper h3,
  .textWrapper b {
    font-size: var(--cxy-fontSize-xxl);
    line-height: var(--cxy-lineHeight-xl);
    font-weight: var(--cxy-fontWeight-bold);
  }
  .textWrapper p {
    font-size: var(--cxy-fontSize-l);
    line-height: var(--cxy-lineHeight-l);
    font-weight: var(--cxy-fontWeight-light);
  }
}
@media (min-width: 1024px) {
  .textWrapper {
    width: 70%;
    padding-inline-start: var(--cxy-spacing-2);
    padding-inline-end: var(--cxy-spacing-8);
  }
}

.pricingSection {
  display: flex;
  align-items: center;
  padding: var(--cxy-spacing-4);
  gap: var(--cxy-spacing-2);
  color: var(--cxy-color-content-default);
  margin-block-start: var(--cxy-spacing-2);
}
@media (max-width: 800px) {
  .pricingSection {
    display: none;
  }
}
.pricingSection .priceSelection {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
  width: 100%;
  padding: var(--cxy-spacing-4) var(--cxy-spacing-2);
  border-radius: var(--cxy-border-radius-m);
}

[data-fpsm-theme='gazzetta'] .pricingSection .priceSelection {
  background-color: var(--cxy-color-white);
}

[data-fpsm-theme='gazzetta'] .textWrapper p {
  font-family: var(--gz-body-font-family);
}
.pricingSection .priceSelection .term {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-default);
  line-height: var(--cxy-lineHeight-m);
}
.pricingSection .priceSelection .bestValue {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-brand);
  line-height: var(--cxy-lineHeight-m);
  min-height: 20px;
}
.pricingSection .priceSelection .price {
  font-weight: var(--cxy-fontWeight-bold);
  height: 50px;
}
.pricingSection .priceSelection .price .monthlyCost {
  font-size: 37px;
}
.pricingSection .priceSelection .paid {
  font-weight: var(--cxy-fontWeight-bold);
  margin-bottom: var(--cxy-spacing-3);
}
.pricingSection .priceSelection .subscribeButton {
  height: 48px;
  width: 90%;
  text-transform: uppercase;
  font-size: var(--cxy-fontSize-s);
}
.pricingSection .priceSelection .subscribeButton .fullText {
  display: none;
}
.pricingSection .priceSelection .subscribeButton .shortText {
  display: inline;
}
@media (min-width: 1024px) {
  .pricingSection .priceSelection .subscribeButton .fullText {
    display: inline;
  }
  .pricingSection .priceSelection .subscribeButton .shortText {
    display: none;
  }
}
@media (min-width: 801px) and (max-width: 1268px) {
  .pricingSection {
    flex-direction: column;
  }
  .pricingSection .priceSelection > .bestValue {
    display: none;
  }
  .pricingSection .priceSelection > .price {
    font-weight: var(--cxy-fontWeight-bold);
    height: 32px;
  }
  .pricingSection .priceSelection > .price .monthlyCost {
    font-size: var(--cxy-fontSize-l);
  }
  .pricingSection .priceSelection > .subscribeButton {
    height: 36px;
  }
}

.bestValueBorder {
  position: relative;
  border: 2px solid var(--cxy-color-content-default);
  border-radius: var(--cxy-border-radius-l);
  padding: var(--cxy-spacing-4);
}

.bestValueTag {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--cxy-color-content-default);
  color: var(--cxy-color-content-dark);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-bold);
  padding: var(--cxy-spacing-1) var(--cxy-spacing-3);
  border-radius: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .textWrapper h1 {
    text-transform: unset;
  }
}
